import { useEffect, useRef } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { X, Search, Check2Square, List } from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";
import { getUserList, setUserPop } from "../store/api/Users";

const ModalSelectUser = () => {
    const userList = useSelector(state => state.UserReducer.userList);
    const popStatus = useSelector(state => state.UserReducer.userPop);
    const searchData = useRef({});
    const selectedIDs = useRef([]);
    const dispatch = useDispatch();
    const search = () => {
        dispatch(getUserList(searchData.current.Name));
    }
    const setSelectedIDs = (add, id) => {
        if (add) {
            selectedIDs.current.push(id);

        }
        else {
            let indx = selectedIDs.current.indexOf(id);
            selectedIDs.current.splice(indx, 1);
        }
    }
    const select = () => {
        if (popStatus.selectUser) {
            popStatus.selectUser(selectedIDs.current);

        }
        dispatch(setUserPop({ show: false }));
    }
    return (
        <Modal show={popStatus.show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#838fe8' }}><span><List color="white" size={22} />&nbsp;لیست کاربران</span><span onClick={() => dispatch(setUserPop({ show: false }))} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body >
                <div className="form-group">
                    <input type="text" className="form-control" placeholder="نام کاربر" style={{ display: "inline-block", width: "84%" }} onChange={e => searchData.current.Name = e.target.value} />
                    <Button className="group-Btn mt-1" style={{ position: "absolute" }} onClick={search}><Search size={18} /></Button>
                </div>
                <hr style={{ marginBottom: 0 }} />
                {userList &&
                    <div className="mt-1" style={{ maxHeight: "350px", overflowX: "hidden", overflowY: "scroll" }}>
                        <Table >
                            <thead>
                                <tr>
                                    <th style={{ width: "10px", padding: "0" }}></th>
                                    <th style={{ padding: "0" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {userList && Array.isArray(userList) && userList.map((item, i) => {
                                    return (<tr key={i}>
                                        <td><input type="checkbox" onChange={(e) => setSelectedIDs(e.target.checked, item.ID)} /></td>
                                        <td>{item.Name}</td>
                                    </tr>)
                                }
                                )}
                            </tbody>
                        </Table>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer style={{ direction: "ltr" }}>
                <Button className="btn-success group-Btn" onClick={select}>انتخاب&nbsp;<Check2Square size={14} /></Button>
            </Modal.Footer>
        </Modal>
    )
}
export default ModalSelectUser;